import { Button, Modal, Skeleton, Tabs } from 'antd'
import React, { Suspense } from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { Tenant } from './Tenant'
import { Issuers } from './Issuers/Issuers'
import { Users } from './Users/Users'
import './tenant-details-modal.scss'

const { TabPane } = Tabs

interface TenantDetailsProps {
  tenantId: number
  isVisible: boolean
  onClose: () => void
}

export const TenantDetailsModal = ({ tenantId, isVisible, onClose }: TenantDetailsProps) => (
  <Modal
    className="tenant-detail-modal"
    centered
    open={isVisible}
    width={drawerAndModalWidth}
    onCancel={onClose}
    footer={[
      <Button key="close" onClick={onClose}>
        Ok
      </Button>,
    ]}
  >
    <Suspense fallback={<Skeleton />}>
      <Tabs defaultActiveKey="details" size="large">
        <TabPane tab="Tenant Details" key="details">
          <Tenant tenantId={tenantId} />
        </TabPane>
        <TabPane tab="Banks" key="banks">
          <Issuers tenantId={tenantId} />
        </TabPane>
        <TabPane tab="Users" key="users">
          <Users tenantId={tenantId} />
        </TabPane>
      </Tabs>
    </Suspense>
  </Modal>
)
